/** "Ink and gold": the colours of the plane and of the paint. */

export type RGB = [number, number, number];

export function hexToRgb(hex: string): RGB {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.replace(/(.)/g, '$1$1') : h, 16);
  return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255];
}

export const COLORS = {
  indigo: '#141a3a',
  parchment: '#efe6d2',
  ink: '#22397a',
  vermilion: '#cf4529',
  gold: '#c9a227',
  ivory: '#fbf6e9',
  line: '#19214d',
} as const;

/** Paint roles in order: ink, vermilion, gold, ivory. */
export const PAINT = [
  { name: 'Ink', hex: COLORS.ink },
  { name: 'Vermilion', hex: COLORS.vermilion },
  { name: 'Gold', hex: COLORS.gold },
  { name: 'Ivory', hex: COLORS.ivory },
] as const;

/**
 * Rotation classes: each class gets its own paper and ink (vermilion, gold and ivory stay).
 * Eight entries, enough for every preset (the largest, {8,3}, needs 8).
 */
export const CLASS_COLOURS: readonly { ground: string; ink: string; name: string }[] = [
  { ground: '#efe6d2', ink: '#22397a', name: 'parchment / ultramarine' },
  { ground: '#d5e4df', ink: '#0f5f5c', name: 'celadon / teal' },
  { ground: '#dee7cc', ink: '#2e6a2b', name: 'sage / green' },
  { ground: '#f0e0b4', ink: '#7a5710', name: 'straw / ochre' },
  { ground: '#f1d7c5', ink: '#6e2c10', name: 'shell / umber' },
  { ground: '#ecd3e3', ink: '#6b2462', name: 'rose / plum' },
  { ground: '#dcd7ef', ink: '#41298a', name: 'lavender / violet' },
  { ground: '#e2ded4', ink: '#2b323f', name: 'stone / charcoal' },
];
